import React from 'react';
import PropTypes from 'prop-types';
import _e from 'common/localeUtil';
import FormFieldOneInput from './fields/FormFieldOneInput';

const GoogleAnalyticsForm = ({ errorMessage }) => {
	return (
		<FormFieldOneInput
			errorMessage={errorMessage}
			description={_e('add_google_analytics')}
			fieldName="google_analytics"
			placeholder={`Google analytics key`}
		/>
	);
};

GoogleAnalyticsForm.propTypes = {
	errorMessage: PropTypes.string,
};

export default GoogleAnalyticsForm;
